/**
 * PORTED — RO-3-00f / #44473.
 * Origin: `excellent/app/_home/property-analytics-card.tsx`.
 *
 * Cause A rewrite: vault read (`propertyAnalytics` + `loadPropertyConfigs`)
 * moved to `homePortfolio.propertyAnalytics`.
 */

import {
  Card,
  SectionTitle,
  StatCard,
  formatUsd,
  formatNumber,
} from "@excellent/ui";
import { useApi } from "@excellent/ui/api";
import { homePortfolio } from "@excellent/ui/api/contracts/home-portfolio";

export function PropertyAnalyticsCard({
  workspaceId,
  projectId,
}: {
  workspaceId: number;
  projectId: number;
}) {
  const { data, isLoading } = useApi(homePortfolio.propertyAnalytics, {
    query: { workspaceId, projectId },
  });

  if (isLoading || !data) return null;
  if (data.metrics.length === 0) return null;

  return (
    <Card>
      <SectionTitle
        title="Analytics"
        subtitle={`Metric profile${data.section ? ` · rolls into ${data.section}` : ""} — the ${data.metrics.length} KPIs this property's kind makes relevant`}
      />
      <div className="grid grid-cols-2 gap-3 px-4 pb-4 pt-2 sm:grid-cols-3">
        {data.metrics.map((m) => (
          <StatCard
            key={m.metric}
            title={m.label}
            value={m.value == null ? "—" : formatMetricValue(m.value, m.unit)}
            description={m.value == null ? "No data yet" : undefined}
          />
        ))}
      </div>
    </Card>
  );
}

function formatMetricValue(value: number, unit: string): string {
  switch (unit) {
    case "currency":
      return formatUsd(value);
    case "percent":
      return `${formatNumber(value)}%`;
    case "ratio":
      return value.toFixed(2);
    case "duration":
      return `${formatNumber(value)} min`;
    default:
      return formatNumber(value);
  }
}
